/* Balkan — favorite (inima din header).

   Lista e in localStorage, pe dispozitivul omului: nu e un wishlist de cont, nu
   se sincronizeaza si nu se vede in admin. Vezi antetul din
   `snippets/balkan-fav-panel.liquid` pentru ce ar cere varianta reala.

   API public (folosit si de cardul de produs):
     window.bkFav.has(handle) / toggle(handle) / list()
     evenimentul `bk:fav` se emite pe document la orice schimbare.          */
(() => {
  if (window.bkFav) return;

  const KEY = 'bk:fav';
  const MAX = 40;

  /* Un browser in mod privat, cu stocarea blocata, arunca la simpla citire.
     Favoritele sunt un lucru placut, nu o functie critica: daca stocarea nu
     merge, lista ramane goala si restul paginii functioneaza normal. */
  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]').filter((h) => typeof h === 'string'); }
    catch { return []; }
  };
  const write = (a) => {
    try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, MAX))); } catch { /* stocare blocata */ }
    document.dispatchEvent(new CustomEvent('bk:fav', { detail: { list: a } }));
  };

  const api = {
    list: read,
    has: (h) => read().includes(h),
    toggle: (h) => {
      const a = read();
      const i = a.indexOf(h);
      if (i > -1) a.splice(i, 1); else a.unshift(h);
      write(a);
      return i === -1;
    },
    remove: (h) => { const a = read().filter((x) => x !== h); write(a); },
  };
  window.bkFav = api;

  /* ---------------------------------------------------------- sincronizare */

  const paint = () => {
    const list = read();
    document.querySelectorAll('[data-bk-fav-count]').forEach((el) => {
      el.textContent = String(list.length);
      el.hidden = list.length === 0;
    });
    document.querySelectorAll('[data-bk-fav-btn]').forEach((b) => {
      const on = list.includes(b.dataset.handle);
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', String(on));
      b.setAttribute('aria-label', on ? 'Scoate din favorite' : 'Adaugă la favorite');
    });
  };
  document.addEventListener('bk:fav', paint);
  // alt tab al aceluiasi magazin a schimbat lista
  addEventListener('storage', (e) => { if (e.key === KEY) paint(); });

  /* Butonul de pe cardul de produs. Delegat, deci merge si pe cardurile care
     vin prin fetch (rafturile paginii principale, fragmentul de catalog). */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-bk-fav-btn]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    api.toggle(b.dataset.handle);
  });

  /* ---------------------------------------------------------------- panou */

  const root = document.querySelector('[data-bk-fav]');
  if (!root) { paint(); return; }

  const body = root.querySelector('[data-bk-fav-body]');
  const panel = root.querySelector('[data-bk-fav-panel]');
  const cache = new Map();
  let lastFocus = null;

  const money = (cents) =>
    (cents / 100).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' lei';

  const card = (p) => {
    const img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_300x$1$2') : '';
    const sold = p.available === false;
    return `<li class="bkfav__i">
      <a class="bkfav__m" href="${p.url}" tabindex="-1" aria-hidden="true">
        ${img ? `<img src="${img}" alt="" loading="lazy" width="80" height="80">` : ''}
      </a>
      <div class="bkfav__c">
        <a class="bkfav__t" href="${p.url}">${p.title}</a>
        <p class="bkfav__p">${money(p.price)}${sold ? ' · <i>stoc epuizat</i>' : ''}</p>
      </div>
      <button type="button" class="bkfav__rm" data-bk-fav-rm="${p.handle}" aria-label="Scoate ${p.title} din favorite">
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
      </button>
    </li>`;
  };

  const empty = `<div class="bkfav__empty">
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 20.3l-1.3-1.2C6.1 15 3.2 12.4 3.2 9.2 3.2 6.6 5.2 4.6 7.8 4.6c1.5 0 2.9.7 3.8 1.8.9-1.1 2.3-1.8 3.8-1.8 2.6 0 4.6 2 4.6 4.6 0 3.2-2.9 5.8-7.5 9.9z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>
      <p>Nu ai încă produse salvate.</p>
      <p class="bkfav__empty-s">Apasă inima de pe orice produs ca să îl ții minte aici.</p>
    </div>`;

  const render = async () => {
    const list = read();
    if (!list.length) { body.innerHTML = empty; return; }
    body.innerHTML = '<div class="bkfav__load" aria-hidden="true"><span></span><span></span><span></span></div>';
    const items = await Promise.all(list.map(async (h) => {
      if (cache.has(h)) return cache.get(h);
      try {
        const r = await fetch(`/products/${encodeURIComponent(h)}.js`);
        if (!r.ok) return null;                       // produsul a fost scos din magazin
        const p = await r.json();
        cache.set(h, p);
        return p;
      } catch { return null; }
    }));
    const ok = items.filter(Boolean);
    // un produs disparut din magazin nu ramane in lista: altfel ar reveni gol la
    // fiecare deschidere
    if (ok.length !== list.length) write(ok.map((p) => p.handle));
    body.innerHTML = ok.length ? `<ul class="bkfav__list">${ok.map(card).join('')}</ul>` : empty;
  };

  const setOpen = (on) => {
    if (on) {
      lastFocus = document.activeElement;
      root.hidden = false;
      document.documentElement.classList.add('bk-noscroll');
      requestAnimationFrame(() => { root.classList.add('is-in'); panel.querySelector('[data-bk-fav-close]').focus(); });
      render();
    } else {
      root.classList.remove('is-in');
      document.documentElement.classList.remove('bk-noscroll');
      setTimeout(() => { root.hidden = true; }, 240);
      if (lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
    }
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-bk-fav-open]')) { e.preventDefault(); setOpen(true); return; }
    if (e.target.closest('[data-bk-fav-close]') || e.target.closest('[data-bk-fav-scrim]')) { setOpen(false); return; }
    const rm = e.target.closest('[data-bk-fav-rm]');
    if (rm) { api.remove(rm.dataset.bkFavRm); render(); }
  });
  addEventListener('keydown', (e) => { if (e.key === 'Escape' && !root.hidden) setOpen(false); });

  paint();
})();
